import type { CSSProperties, ReactElement, ReactNode, RefObject } from 'react';
import { motion } from 'framer-motion';
import { Ccontainer } from '../Ccontainer';
import { ContainerPreset, ModalLocation } from '@/constants/componentPresets';
import type { ColorType } from '@/theme/colors';
import { CMODAL_TILE_BACKDROP_BLUR, CMODAL_TILE_RADIUS, CSS_FULL_SIZE, } from './Cmodal.constants';
import { CmodalBackButton } from './CmodalBackButton';
import { CmodalContent } from './CmodalContent';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CmodalTileProps {
    dataElScope: DataElScope;
    tileWrapperRef: RefObject<HTMLDivElement | null>;
    tileRootRef: RefObject<HTMLDivElement | null>;
    contentRef: RefObject<HTMLDivElement | null>;
    mainContentRef: RefObject<HTMLDivElement | null>;
    location: ModalLocation;
    animationDuration: number;
    backButtonStyle: CSSProperties;
    onClose: () => void;
    modalTileWrapperStyle: CSSProperties;
    modalTileStyle: CSSProperties;
    padding: number;
    useContainerBackground: boolean;
    background: ColorType;
    backgroundOpacity: number;
    content?: ReactNode;
    menuTitle?: string;
    titleExtra?: string;
    titleRightComponent?: ReactNode;
}
export function CmodalTile({ dataElScope, tileWrapperRef, tileRootRef, contentRef, mainContentRef, location, animationDuration, backButtonStyle, onClose, modalTileWrapperStyle, modalTileStyle, padding, useContainerBackground, background, backgroundOpacity, content, menuTitle, titleExtra, titleRightComponent, }: CmodalTileProps): ReactElement {
    return (<>
      {/* The close button lives INSIDE this motion element so the tile's single
          enter/exit transform carries it; it owns no motion props of its own.
          `modalTileWrapperStyle` is `position: relative` and, for a centre
          modal, shares the content wrapper's box (both `height: auto`, this one
          `width: 100%`), so the button's absolute top/right anchor is unchanged. */}
      <motion.div data-el={dataEl(dataElScope, 'Tile/Root')} ref={tileWrapperRef} initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: animationDuration / 1000, ease: [0.4, 0, 0.2, 1] }} style={modalTileWrapperStyle}>
        {location === ModalLocation.Center && (<CmodalBackButton dataElScope={dataElScope} backButtonStyle={backButtonStyle} onClose={onClose}/>)}
        <Ccontainer preset={ContainerPreset.Tile} padding={padding} backgroundColor={useContainerBackground ? background : undefined} backgroundOpacity={useContainerBackground ? backgroundOpacity : undefined} radius={CMODAL_TILE_RADIUS} backdropBlur={CMODAL_TILE_BACKDROP_BLUR} width="100%" height={location === ModalLocation.Center ? undefined : CSS_FULL_SIZE} flexDirection="column" rootRef={tileRootRef} style={modalTileStyle}>
          <CmodalContent dataElScope={dataElScope} contentRef={contentRef} mainContentRef={mainContentRef} location={location} content={content} menuTitle={menuTitle} titleExtra={titleExtra} titleRightComponent={titleRightComponent}/>
        </Ccontainer>
      </motion.div>
    </>);
}
